export const NAME_FIELD_NAME = 'name'
export const TYPE_FIELD_NAME = 'type'
export const IS_TEST_FIELD_NAME = 'isTest'
export const ENABLED_FIELD_NAME = 'enabled'

// AdCompany fields
export const IS_REFERRAL_SOURCE_REQUIRED = 'isReferralSourceRequired'
export const IS_NEXT_CALL_DATE_REQUIRED = 'isNextCallDateRequired'
export const IS_TASK_DUE_DATE_REQUIRED = 'isTaskDueDateRequired'
export const IS_TEST = 'isTest'
export const IS_ENABLED = 'enabled'
export const IS_PATIENT_GAMIFICATION_ENABLED = 'isPatientGamificationEnabled'
export const IS_CARE_GIVER_GAMIFICATION_ENABLED =
  'isCareGiverGamificationEnabled'
export const IS_TELEMEDICINE_BILLABLE = 'isTeleMedicineBillable'
export const IS_MEDICATION_NOTIFICATIONS_ENABLED =
  'isMedicationNotificationsEnabled'
export const IS_PCC_MEASUREMENT_EXPORT_ON = 'pccMeasurementExportOn'
export const IS_BILLABLE = 'isBillable'
export const IS_OVERLAP_VALIDATION_ENABLED = 'isOverlapValidationEnabled'
export const CHECK_IN_EXPIRE_HOURS = 'checkInExpireHours'
export const READ_ONLY_CHAT = 'readOnlyChat'
export const IS_URGENT_CARE_LOAD_BALANCING = 'isUrgentCareLoadBalancing'
export const IS_URGENT_CARE_TRIAGE_NURSE = 'isUrgentCareTriageNurse'
export const IS_URGENT_CARE_CALL_REASON_REQUIRED =
  'isUrgentCareCallReasonRequired'
export const IS_URGENT_CARE_OUTCOME_NOTE_REQUIRED =
  'isUrgentCareOutcomeNoteRequired'
export const IS_URGENT_CARE_OUTCOME_NOTES_BLOCKING =
  'isUrgentCareOutcomeNotesBlocking'
export const SHOW_URGENT_CARE_OUTCOME_NOTE = 'showUrgentCareOutcomeNote'
export const IS_SET_CONSENT_DATE_WITH_FIRST_ACTIVITY =
  'isSetConsentDateWithFirstActivity'
export const IS_SHOW_RPM_BILLABLE = 'isShowRpmBillable'
export const GOAL_CATEGORY_UUID_ON_CCM_CREATION =
  'goalCategoryUuidOnCcmCreation'
export const GOAL_UUID_ON_CCM_CREATION = 'goalUuidOnCcmCreation'
export const GOAL_CATEGORY_UUID_ON_RPM_CREATION =
  'goalCategoryUuidOnRpmCreation'
export const GOAL_UUID_ON_RPM_CREATION = 'goalUuidOnRpmCreation'
export const COMPANY_NAME = 'name'
export const TIMEZONE = 'timezone'
export const COMPANY_TYPE = 'type'
export const DEFAULT_LANGUAGE = 'defaultLanguage'
export const USER_CREATION_TYPE = 'userCreationType'
export const CHANGE_PASSWORD_REQUIREMENT = 'changePasswordRequirement'
export const PASSWORD_EXPIRY_WARNING_DAYS = 'passwordExpiryWarningDays'
export const DEFAULT_BILLING_PROGRAM_UUID = 'defaultBillingProgramUuid'
export const DEFAULT_PATIENT_DOCUMENT_TYPE = 'defaultPatientDocumentType'
export const IS_ASK_TO_REPORT_CLINICAL_EVENT = 'isAskToReportClinicalEvent'
export const DEFAULT_TELEMEDICINE_BILLED_BY = 'defaultTelemedicineBilledBy'
export const BILLABLE_ACTIVITY = 'billableActivity'
export const TECHNICAL_CONTACT_NAME = 'technicalContactName'
export const TECHNICAL_CONTACT_EMAIL = 'technicalContactEmail'
export const TECHNICAL_CONTACT_PHONE = 'technicalContactPhone'
export const BILLING_CONTACT_PERSON = 'billingContactPerson'
export const BILLING_CONTACT_EMAIL = 'billingContactEmail'
export const BILLING_CONTACT_PHONE = 'billingContactPhone'
export const APPOINTMENT_OVERLAPPING_TYPE = 'appointmentOverlappingType'
export const DEFAULT_APPOINTMENTS_PAGE = 'defaultAppointmentsPage'
export const IS_START_TIMER_ON_ALERT_ACTION = 'isStartTimerOnAlertAction'
export const IS_ENABLED_ACTIVITY_LOG_FACILITY_NOTIFICATION =
  'isEnabledActivityLogFacilityNotification'
export const CHECK_SECURED_EMAIL_PASSWORD = 'checkSecuredEmailPassword'
export const IS_MARKETER_DAILY_REPORT_ENABLED = 'isMarketerDailyReportEnabled'
export const CAN_HAVE_NON_BILLABLE_MEASUREMENTS =
  'canHaveNonBillableMeasurements'
export const IS_APPOINTMENT_OUTCOME_NOTE_REQUIRED =
  'isAppointmentOutcomeNoteRequired'
export const IS_APPOINTMENT_CALLBACK_FIELDS_REQUIRED =
  'isAppointmentCallbackFieldsRequired'
export const APPOINTMENT_CALLBACK_FIELDS_MODE = 'appointmentCallbackFieldsMode'
export const APPOINTMENT_CALLBACK_FIELDS_MODE_ENUM = {
  HIDDEN: 0,
  OPTIONAL: 1,
  REQUIRED: 2
}
export const APPOINTMENT_CALLBACK_FIELDS_MODE_OPTIONS = [
  {
    value: APPOINTMENT_CALLBACK_FIELDS_MODE_ENUM.HIDDEN,
    label: 'Hidden'
  },
  {
    value: APPOINTMENT_CALLBACK_FIELDS_MODE_ENUM.OPTIONAL,
    label: 'Optional'
  },
  {
    value: APPOINTMENT_CALLBACK_FIELDS_MODE_ENUM.REQUIRED,
    label: 'Required'
  }
]
export const IS_ALLOW_SIMPLE_UI_FOR_URGENT_CARE_CAREGIVERS =
  'isAllowSimpleUiForUrgentCareCaregivers'
export const IS_DISPLAY_CONSENT_FORM = 'isDisplayConsentForm'
export const PATIENT_REQUESTED_APPOINTMENT_ALLOWED =
  'patientRequestedAppointmentAllowed'
export const CAN_CREATE_G0506_FROM_APPOINTMENT = 'canCreateG0506FromAppointment'
export const IS_REFERRAL_FOLLOW_UP_NOTIFICATION =
  'isReferralFollowUpNotification'
export const REFERRAL_FOLLOW_UP_STATUS_FROM = 'referralFollowUpStatusFrom'
export const REFERRAL_FOLLOW_UP_STATUS_TO = 'referralFollowUpStatusTo'
export const IS_INCLUDE_APPOINTMENTS_WITH_OUTCOMES_ONLY_TO_UC_REPORT =
  'isIncludeAppointmentsWithOutcomesOnlyToUcReport'
export const IS_DELETE_APPOINTMENTS_ON_DISCHARGE =
  'isDeleteAppointmentsOnDischarge'
export const IS_ENABLED_ACTIVITY_LOG_CARE_GAP = 'isEnabledActivityLogCareGap'
export const IS_EMR_CAREGIVER_MANAGEMENT = 'emrCareGiverManagement'
export const ADVANCE_DIRECTIVE_CONTENT = 'advanceDirectiveContent'
export const SESSION_ACTIVITY_TIMER = 'sessionActivityTimer'
export const UPDATE_CLINICIAN_ON_APPOINTMENT = 'updateClinicianOnAppointment'
export const IS_AI_HELPER_COPY_ENABLED = 'isAIHelperCopyEnabled'
export const IS_PRE_CALL_BRIEF_ENABLED = 'isPreCallBriefEnabled'
export const PRE_CALL_BRIEF_WRITER_PROMPT_ARN = 'preCallBriefWriterPromptArn'
export const PRE_CALL_BRIEF_REVIEWER_PROMPT_ARN =
  'preCallBriefReviewerPromptArn'
export const IS_MEETING_RISK_ENABLED = 'isMeetingRiskEnabled'
export const IS_UC_RISK_ENABLED = 'isUCRiskEnabled'
export const IS_MEETING_RECORDING_ENABLED = 'isMeetingRecordingEnabled'
export const IS_UC_RECORDING_ENABLED = 'isUCRecordingEnabled'
export const LOCK_PATIENT_WITH_DRAFT_VISIT = 'lockPatientWithDraftVisit'
export const IS_FORCE_CALL_BACKGROUND_IMAGE = 'isForceCallBackgroundImage'
// Edited in the company profile Waiting Room Video section, not in the company
// form, but still has to travel with every company PATCH.
export const URGENT_CARE_WAITING_ROOM_VIDEO_ENABLED =
  'urgentCareWaitingRoomVideoEnabled'
export const APPOINTMENT_WAITING_ROOM_VIDEO_ENABLED =
  'appointmentWaitingRoomVideoEnabled'
export const IS_ALERT_AI_SUMMARY_ENABLED = 'isAlertAISummaryEnabled'
export const IS_ALERT_AI_SUMMARY_AUTOMATIC_ENABLED =
  'isAlertAISummaryAutomaticEnabled'

export const COMPANY_TYPES = [
  {
    key: 1,
    value: 1,
    label: 'Physician'
  },
  {
    key: 2,
    value: 2,
    label: 'Payer'
  },
  {
    key: 3,
    value: 3,
    label: 'Urgent Care'
  }
]

export const DEFAULT_APPOINTMENT_PAGES = [
  {
    key: 1,
    value: 1,
    label: 'Calendar'
  },
  {
    key: 2,
    value: 2,
    label: 'List'
  }
]

export const APPOINTMENT_OVERLAPPING_TYPES = [
  {
    key: 1,
    value: 1,
    label: 'Allow meeting overlaps'
  },
  {
    key: 2,
    value: 2,
    label: 'Show warning'
  },
  {
    key: 3,
    value: 3,
    label: "Don't allow meeting overlaps"
  }
]
